import { AnalyticLightNode } from "three/webgpu";
import { useAuth } from "../providers/AuthProvider";
import { BASE_URL, USE_JWT } from "../Config";
const useApi = () => {
  const { authToken } = useAuth();

  const buildParams = (method, is_json=true) => {
    let params = {
      method: method,
      headers: {}
    }
    if(is_json){
      params['headers'] = {
        "Content-Type": "application/json",
      }
    }
    if(USE_JWT){
      params['headers']['Authorization'] = `Bearer ${authToken}`
    }else{
      params['credentials'] = 'include'
    }
    return params;
  }

  const get = async (url) => {
    try {
      const response = await fetch(`${BASE_URL}${url}`, buildParams("GET"));

      if (!response.ok) {
        throw new Error("Error en la solicitud GET");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error en el GET:", error);
      throw error;
    }
  };

  const post = async (url, data) => {
    try {
      let params = buildParams("POST")
      params['body'] = JSON.stringify(data);
      const response = await fetch(`${BASE_URL}${url}`, params);

      if (!response.ok) {
        const reason = await response.text();
        throw new Error(reason);
      }

      const responseJson = await response.json();
      if(responseJson.error){
        throw new Error(responseJson.error);
      }

      return responseJson;
    } catch (error) {
      console.error("Error en el POST:", error);
      throw error;
    }
  };

  const postFile = async (url, data) => {
    try {
      let params = buildParams("POST", false);
      // let params = {
      //   method: "POST",
      //   credentials: "include"
      // }
      params['body'] = data;

      const response = await fetch(`${BASE_URL}${url}`, params);

      if (!response.ok) {
        throw new Error("Error en la solicitud POST");
      }

      const responseJson = await response.json();

      return responseJson;
    } catch (error) {
      console.error("Error en el POST:", error);
      throw error;
    }
  };

  return { get, post, postFile };
};

export default useApi;
